module.exports = __webpack_public_path__ + "img/0-r.ad2db602.png";